<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <v-navigation-drawer
      v-if="!$vuetify.breakpoint.smAndDown"
      :width="$vuetify.breakpoint.mdOnly?56:300"
      app
      color="grey darken-4"
      dark
      permanent
      style="overflow: visible"
      touchless
    >
      <div
        class="d-flex flex-column"
        style="height: 100vh;"
      >
        <navigation-items
          :is-dark-mode="darkMode"
          :is-loading="isLoading"
          :offline-mode="offlineMode"
          class="flex-grow-1"
        />
      </div>
    </v-navigation-drawer>
    <v-app-bar
      :style="!darkMode ? 'border-bottom: 1px solid #aaa' : ''"
      app
      class="headerMobile px-4"
      clipped-right
      color="grey lighten-3"
      elevation="0"
      flat
      height="56"
    >
      <v-container
        class="d-flex align-center pa-0 pl-2"
        fluid
        style="height: 56px"
      >
        <div
          v-if="$vuetify.breakpoint.smAndDown"
          class="ml-2 mr-auto"
        >
          <navigation-dialog
            :is-dark-mode="false"
            :is-loading="isLoading"
            :owned-products="[]"
          />
        </div>
        <div
          v-else
          @click="personInfoDialog=true"
        >
          <restaurant-logo-display />
        </div>
        <v-spacer />
        <v-toolbar-items>
          <v-card
            v-if="checkTestDevice"
            class="d-flex align-center mr-4 pa-2"
            color="info lighten-4"
            elevation="0"
            tile
          >
            <div>
              测试门店
            </div>
          </v-card>
          <v-card
            v-if="checkTestMode === 'InTestMode'"
            class="d-flex align-center mr-4 pa-2"
            color="warning"
            dark
            elevation="0"
            tile
            @click="showFinishTrialDialog"
          >
            <div class="ml-1">
              {{ $t('TrialMode') }}
            </div>
            <v-icon right>
              mdi-close
            </v-icon>
          </v-card>
          <v-btn
            icon
            large
            @click="openApp"
          >
            <v-icon>mdi-bird</v-icon>
          </v-btn>
          <v-btn
            v-if="!loginStatus"
            icon
            large
            @click="$router.push('/products/productsInfo')"
          >
            <v-icon>mdi-store</v-icon>
          </v-btn>
          <v-menu
            content-class="boxShadowReset"
            offset-y
            open-on-click
            open-on-hover
          >
            <template #activator="{on,attrs}">
              <v-btn
                icon
                large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-account</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item,index) in items"
                :key="index"
                @click="personSetting(item)"
              >
                <div class="d-block overflow-hidden">
                  <div class="d-flex align-center">
                    <v-icon>{{ item.icon }}</v-icon>
                    <div
                      class="text-truncate ml-4"
                    >
                      {{ $t(item.title) }}
                    </div>
                  </div>
                </div>
              </v-list-item>
            </v-list>
          </v-menu>

          <language-switcher
            :active="changeLanguage"
            :current-locale-code="currentLocaleCode"
            :locales="$i18n.messages"
            class="mr-4"
            @language-change="changeLanguage"
          />
        </v-toolbar-items>
      </v-container>
    </v-app-bar>
    <v-main style="background: #f5f6f8;min-height: 100vh">
      <v-container
        :class="$vuetify.breakpoint.mdAndUp?'px-6':''"
        fluid
        style="background: transparent"
      >
        <router-view />
      </v-container>
    </v-main>
    <v-dialog
      v-model="personInfoDialog"
      max-width="600"
    >
      <v-card class="py-4">
        <div class="d-flex px-4">
          <div class="text-h3 font-weight-bold">
            {{ $t('RestaurantAdministration') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="personInfoDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <add-device-page
          :dialog-status="personInfoDialog"
          @closeDialog="closeDialog"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="checkTseProduct"
      max-width="600"
    >
      <v-card
        v-if="!checkProductsOwnedTse"
        class="pa-6 d-flex align-center justify-center flex-column"
      >
        <v-icon
          color="error lighten-2"
          size="64"
        >
          mdi-alert-box
        </v-icon>
        <div class="text-h4 mt-6">
          {{ $t('Uwuu') }}
        </div>
        <div class="text-body-2 mt-2 text-center">
          {{ $t('TseRequiredUnderGermanLaw') }}
        </div>
        <div class="text-body-2 text-center">
          {{ $t('IfUAreOutsideGermany') }}
        </div>
        <div class="d-flex align-center justify-center">
          <v-btn
            class="amber lighten-4 black--text mt-4"
            elevation="0"
            @click="buyTse"
          >
            {{ $t('BuyNow') }}
          </v-btn>
          <v-btn
            class="blue lighten-4 black--text mt-4 ml-4"
            elevation="0"
            @click="finishTrialWithOutTse"
          >
            {{ $t('EndTrial') }}
          </v-btn>
        </div>
      </v-card>
      <v-card
        v-else
        class="pa-6 d-flex align-center justify-center flex-column"
      >
        <v-icon
          color="error lighten-2"
          size="64"
        >
          mdi-alert-box
        </v-icon>
        <div class="text-h4 mt-6">
          {{ $t('ThisIsGreat') }}
        </div>
        <div class="text-body-2 mt-2">
          {{ $t('ConfirmEndOfTrialActivateTSENow') }}
        </div>
        <v-btn
          :loading="creatTseLoading"
          class="blue lighten-4 black--text mt-4"
          elevation="0"
          @click="finishTrial"
        >
          {{ $t('EndTrial') }}
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="milkTeaQr"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex">
          <div class="text-h3 font-weight-bold">
            {{ $t('DownloadMilkTeaApp') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="milkTeaQr = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex justify-center align-center flex-column py-6">
          <qr-code-display
            :data="'https://aaden.online/123.apk'"
            :size="'196'"
            class="mt-4"
          />
          <a
            :href="'https://aaden.online/123.apk'"
            class="mt-2"
            target="_blank"
          >{{ 'https://aaden.online/123.apk' }}</a>
        </div>
      </v-card>
    </v-dialog>
    <brand-invite-dialog />
  </div>
</template>

<script>
import LanguageSwitcher from '@/views/widget/commonLogic/LanguageSwitcher.vue'
import GlobalConfig, { changeLanguage, Remember, requireOfflineMode } from '@/model/global/GlobalSettings'
import { getNiceRestaurantInfo } from '@/model/dataLayer/service/otherService'
import NavigationDialog from '@/views/AppIndex/NavigationDialog'
import AddDevicePage from '@/views/AppIndex/Widget/FilialeManage.vue'
import BrandInviteDialog from '@/views/AppIndex/Widget/BrandInviteDialog.vue'

import NavigationItems from '@/views/AppIndex/NavigationItems'
import { mapMutations, mapState } from 'vuex'
import { endTrialMode, missionList } from '@/model/dataLayer/api/SaaS/guide'
import { ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import { creatTse } from '@/model/dataLayer/service/tseServe'
import { getActiveProductCode, getCurrentStoreId } from '@/model/dataLayer/api/SaaS/user'
import { findDeviceByDeviceId } from '@/model/dataLayer/api/SaaS/subscriptionService'
import QrCodeDisplay from '@/views/SaaS/widget/QrCodeDisplay'
import { getBaseAndUrlForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import RestaurantLogoDisplay from '@/views/widget/commonLogic/RestaurantLogoDisplay.vue'
import store from '@/model/global/store'
import { touchPoint } from '@/model/global/Login'

export default {
  name: 'AppIndex',

  components: {
    RestaurantLogoDisplay,
    AddDevicePage,
    BrandInviteDialog,
    LanguageSwitcher,
    NavigationDialog,
    QrCodeDisplay,
    NavigationItems
  },
  props: {
    isDarkMode: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      trialImg: '../assets/icon/trial.png',
      milkTeaQr: false,
      loading: false,
      haveSync: false,
      needUpload: [],
      needUpdateLocal: [],
      needAddLocal: [],
      needUpdateRemote: [],
      creatTseLoading: false,
      checkTseProduct: false,
      currentStoreInfo: null,
      activeProductCodeList: [],
      missionList,
      guideSchedule: 0,
      realMissionList: [],

      activeTseLoading: false,
      showTseOpenDialog: false,

      isLoading: false,
      darkMode: this.isDarkMode,
      items: [
        {
          title: 'PersonalInformation',
          value: '1',
          icon: 'mdi-account-badge'
        },
        {
          title: 'RestaurantAdministration',
          value: '2',
          icon: 'mdi-home-switch'
        },
        {
          title: 'Logout',
          value: '3',
          icon: 'mdi-logout'
        }
      ],
      personInfoDialog: false,
      deviceId: -1,
      restaurantInfo: null,
      offlineMode: requireOfflineMode()
    }
  },

  computed: {
    loginStatus () {
      return Remember.offlineMode
    },
    ...mapState(['loadingType']),
    showLoading: {
      get () {
        return this.$store.state.showLoading
      },
      set (val) {
        if (!val) {
          this.hideLoading()
        }
      }
    },
    checkTestMode () {
      return this.currentStoreInfo?.testModeStatus ?? 'oldDevice'
    },
    checkTestDevice () {
      return store.state.adminTest
    },
    checkProductsOwnedTse () {
      return this.activeProductCodeList.includes(ProductCodes.tse)
    },
    restaurantName () {
      return this.restaurantInfo?.name ?? ''
    },
    currentLocaleCode () {
      return this.$i18n.locale
    }
  },

  async mounted () {
    await this.reload()
  },
  methods: {
    ...mapMutations(['showProductPage', 'showProductDetail']),
    buyTse () {
      this.creatTseLoading = false
      this.showProductDetail({ code: ProductCodes.tse })
    },
    async finishTrialWithOutTse () {
      this.creatTseLoading = true
      await endTrialMode()
      this.creatTseLoading = false
      this.checkTseProduct = false
      location.reload()
    },
    async finishTrial () {
      this.creatTseLoading = true
      await endTrialMode()
      await creatTse(GlobalConfig.DeviceId)
      this.checkTseProduct = false
      location.reload()
    },
    showFinishTrialDialog () {
      this.checkTseProduct = true
    },
    async openApp () {
      if (this.activeProductCodeList.includes(ProductCodes.restaurant)) {
        const { url } = await getBaseAndUrlForDeviceId(await getCurrentStoreId())
        const res = url.split('//')[1]
        const link = location.protocol + '//app-beta.aaden.io/?Base=' + res
        this.showProductPage(link)
      } else {
        this.milkTeaQr = true
      }
    },
    ...mapMutations(['showErrorDialog', 'showProductDetail']),
    async logout () {
      await touchPoint({
        type: 'logout',
        token: null
      })
      location.reload()
    },
    personSetting (item) {
      if (item.value === '1') {
        this.$router.push('/personalInfo')
      } else if (item.value === '2') {
        this.personInfoDialog = true
      } else {
        this.logout()
      }
    },
    async closeDialog (needReload) {
      this.personInfoDialog = false
      if (needReload) {
        await this.reload()
      }
    },
    async reload () {
      try {
        this.restaurantInfo = await getNiceRestaurantInfo()
        this.isLoading = true
        this.currentStoreInfo = { testModeStatus: 'oldDevice' }
        if (!requireOfflineMode()) {
          this.currentStoreInfo = await findDeviceByDeviceId(GlobalConfig.DeviceId)
          this.activeProductCodeList = await getActiveProductCode()
        }
      } catch (e) {
        console.log(e)
      }
      this.isLoading = false
    },

    changeLanguage (locale) {
      Remember.locale = locale
      this.$i18n.locale = Remember.locale
      changeLanguage(locale)
      location.reload()
    }
  }
}
</script>

<style>
.selectedBarItemClass {
  border-radius: 2px;
  bottom: -12px;
  height: 2px;
  width: 100%;
  background: var(--v-primary-base);
}

.headerMobile .v-toolbar__content {
  padding: 0 !important;
}

</style>
